<template>
  <div class="container py-5">
    <JobDescriptionHeader
        title="مسئولیت‌های شغلی، گروه‌های افراد، ارتباطات و شرح وظایف"
        description="در این بخش می‌توانید مسئولیت‌های شغلی، گروه‌های افراد، ارتباطات سازمانی و شرح وظایف را ایجاد و به‌روزرسانی کنید"
    />

    <div class="row mt-4">
      <div class="col-md-12">
        <ResponsibilitiesSection/>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-6">
        <PeopleGroupsSection/>
      </div>
      <div class="col-md-6">
        <OrganizationalCommunicationsSection/>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <DutiesDescriptionSection/>
      </div>
    </div>

    <NavigationButtons @next="$emit('next')" @prev="$emit('prev')" />
  </div>
</template>

<script>
import ResponsibilitiesSection from "@/components/JobDescription/StepFour/ResponsibilitiesSection.vue";
import NavigationButtons from "@/components/JobDescription/GeneralComponents/NavigationButtons.vue";
import JobDescriptionHeader from "@/components/JobDescription/GeneralComponents/JobDescriptionHeader.vue";
import OrganizationalCommunicationsSection from "@/components/JobDescription/StepFour/OrganizationalCommunicationsSection.vue";
import PeopleGroupsSection from "@/components/JobDescription/StepFour/PeopleGroupsSection.vue";
import DutiesDescriptionSection from "@/components/JobDescription/StepFour/DutiesDescriptionSection.vue";
import CoursesSection from "@/components/JobDescription/StepTwo/CoursesSection.vue";
import RelatedSoftwareSection from "@/components/JobDescription/StepTwo/RelatedSoftwareSection.vue";

export default {
  components: {
    RelatedSoftwareSection,
    CoursesSection,
    DutiesDescriptionSection, PeopleGroupsSection, OrganizationalCommunicationsSection, JobDescriptionHeader, NavigationButtons, ResponsibilitiesSection }
};
</script>
